import React from 'react'

function Info(){
    return (
        <div>
            Dashboard Info Dialog<br/>
            this should be quick reference slides highlighting the features of the Dashboard.
        </div>
    )
}
export default Info
